import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import UserContext from '../../contexts/UserContext';
import { useNavigate, useLocation } from 'react-router-dom'; 
import { IoMdAdd } from "react-icons/io";
import displayError from '../../utils/ErrorHandler';
import authenticate from '../../utils/Authenticate';


const ReturnItemMiqaat = () => {
  const { user,setUser } = useContext(UserContext);
  const [stock, setStock] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchItem, setSearchItem] = useState('');
  const [quantity, setQuantity] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [addedItems, setAddedItems] = useState([]);
  const [error, setError] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const [error2, setError2] = useState(null);
  const [success, setSuccess] = useState(false);
  const [message,setMessage] = useState('')
  const location = useLocation();
  const { miqaatDetails } = location.state || {};

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user])

  useEffect(() => {
    getItems();
  }, []);

  const getItems = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URI}/api/stock/getStockouts`, { miqaat: miqaatDetails }, { withCredentials: true });
      if (response.data.success) {
        console.log(response.data.data[0].items);
        setStock(response.data.data[0].items);
        setFilteredItems(response.data.data[0].items);
      }
    } catch (err) {
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setMessage(errorMessage)
          }
    }
  };

  const handleSearchChange = (e) => {
    setSearchItem(e.target.value);
    if (e.target.value) {
      const filtered = stock.filter(item =>
        item.item.name.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setFilteredItems(filtered);
    } else {
      setFilteredItems(stock);
    }
  };

  const handleItemSelect = (item) => {
    setSelectedItem(item);
    setSearchItem(item.item.name);
    setFilteredItems([]);
    setShowDropdown(false);
    setError('');
  };

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    setQuantity(value);
    if (selectedItem && value > selectedItem.quantity) {
      setError('Not enough stock');
    } else {
      setError('');
    }
  };

  const handleAddItem = () => {
    if (selectedItem && quantity && quantity <= selectedItem.quantity) {
      const updatedItems = [...addedItems];
      const existingItemIndex = updatedItems.findIndex(item => item.item._id === selectedItem.item._id);
      if (existingItemIndex >= 0) {
        updatedItems[existingItemIndex].quantity = quantity;
      } else {
        updatedItems.push({ ...selectedItem, quantity });
      }
      setAddedItems(updatedItems);
      setSearchItem('');
      setQuantity('');
      setSelectedItem(null);
      setError('');
    } else if (quantity > selectedItem.quantity) {
      setError('Not enough stock');
    }
  };

  const handleFocus = () => {
    setShowDropdown(true);
    setFilteredItems(stock);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 200);
  };

  const returningStock = async (stockoutObj) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URI}/api/stock/return`, stockoutObj, { withCredentials: true });
      if (response.data.message === "Stock updated successfully !") {
        setSuccess(true);
        setAddedItems([]);
        await getItems();
      }
    } catch (error) {
      setError2(error);
    }
  };

  const handleSubmit = () => {
    const items = addedItems.map(item => ({
      name: item.item.name,
      quantity: item.quantity,
    }));

    const stockoutObj = {
      items: items,
      miqaat: miqaatDetails
    };

    returningStock(stockoutObj);
  };

  const handleDeleteItem = (index) => {
    const updatedItems = [...addedItems];
    updatedItems.splice(index, 1);
    setAddedItems(updatedItems);
  };

  return (
    <>
      <div className="bg-lime-800 flex items-center justify-between w-full p-4 text-white">
        <h4 className="text-lg md:text-xl font-semibold text-center flex-grow">Return Items to Inventory</h4>
      </div>
      <div className="p-4 max-w-xl mx-auto">
        {error2 && <div className="bg-red-100 text-red-700 p-2 mb-4">{error2}</div>}
        {success && <div className="bg-green-100 text-green-700 p-2 mb-4">Inventory Updated!</div>}

        <div className="mb-4 relative grid grid-cols-5 gap-2">
          <div className="col-span-3">
            <label className="block text-[13px] font-medium text-gray-700">Item Name</label>
            <input
              type="text"
              value={searchItem}
              onChange={handleSearchChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              className="text-[13px] mt-1 block w-full pl-3 pr-3 py-2 border bg-white border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              placeholder="Search Item"
            />
            {showDropdown && filteredItems.length > 0 && (
              <ul className="border border-gray-300 mt-1 max-h-60 overflow-auto absolute bg-white z-10 w-full">
                {filteredItems.map(item => (
                  <li
                    key={item._id}
                    className="text-[13px] px-4 py-2 cursor-pointer hover:bg-gray-100"
                    onMouseDown={() => handleItemSelect(item)}
                  >
                    {item.item.name} (Stock: {item.quantity})
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Quantity</label>
            <input
              type="number"
              onWheel={(e) => e.target.blur()}
              value={quantity}
              onChange={handleQuantityChange}
              className={`mt-1 block w-full pl-3 pr-3 py-2 border ${error ? 'border-red-500' : 'border-gray-300'} bg-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md`}
            />
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
          </div>
          <div>
            <label className="block text-[13px] font-medium text-gray-700">Units</label>
            <input
              type="text"
              value={selectedItem ? selectedItem.item.unit : ''}
              disabled
              className="mt-1 block w-full pl-3 pr-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md bg-gray-100"
            />
          </div>
        </div>

        <button
          onClick={handleAddItem}
          className="mb-4 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
        >
          Add Item
        </button>

        <div className="mt-4">
          {addedItems.map((item, index) => (
            <div key={index} className="p-4 bg-white border border-gray-300 rounded-md mb-2 flex justify-between items-center transition-all duration-300 hover:bg-gray-100">
              <p className="text-sm font-medium text-gray-700">{item.item.name}</p>
              <div className="flex items-center space-x-2">
                <p className="text-sm text-gray-700 font-semibold">{item.quantity} {item.item.unit}</p>
                <button onClick={() => handleDeleteItem(index)} className="text-red-600 hover:text-red-800 focus:outline-none">
                  <svg className="h-5 w-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M14.1 15.3l-1.4 1.4-3.7-3.7-3.7 3.7-1.4-1.4 3.7-3.7-3.7-3.7 1.4-1.4 3.7 3.7 3.7-3.7 1.4 1.4-3.7 3.7 3.7 3.7z"/></svg>
                </button>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={handleSubmit}
          disabled={addedItems.length === 0}
          className={`fixed bottom-[80px] left-1/2 transform -translate-x-1/2 w-11/12 max-w-md inline-flex items-center justify-center px-4 py-2 border border-transparent text-white font-medium rounded-md shadow-sm ${addedItems.length === 0 ? 'bg-gray-400' : 'bg-fmb'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fmbrown transition-all duration-300`}
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default ReturnItemMiqaat;
